import FunctionHelper from "../helper/FunctionHelper";
import {Parameter, RubberStampAnnotation} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";

export class PortalRubberStampAnnotation extends RubberStampAnnotation implements Parameter {
	public borderColor?: string;
	public fontColor?: string;
	public fontSize?: number;
	public text?: string;

	constructor(data: any) {
		super(data);

		this.borderColor = FunctionHelper.exists(data?.text) ? data.borderColor : "#BBBBBB";
		this.fontColor = FunctionHelper.exists(data?.text) ? data.fontColor : "#666666";
		this.fontSize = FunctionHelper.exists(data?.text) ? data.fontSize : 26;
		this.text = FunctionHelper.exists(data?.text) ? data.text : "";
	}

	public static getBorderColorDefault(): string {
		return "#BBBBBB";
	}

	public static getFontColorDefault(): string {
		return "#666666";
	}

	public static getFontSizeDefault(): number {
		return 26;
	}

	public static getFontSizeMin(): number {
		return 8;
	}

	public static getFontSizeMax(): number {
		return 72;
	}

	public static getTextDefault(): string {
		return "";
	}

	public static fromJson(data: any): PortalRubberStampAnnotation {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalRubberStampAnnotation(data);
	}

	public toJson(): any {
		return {
			...super.toJson(),
			'borderColor': this.borderColor,
			'fontColor': this.fontColor,
			'fontSize': this.fontSize,
			'text': this.text
		};
	}

	public clone(): PortalRubberStampAnnotation {
		return PortalRubberStampAnnotation.fromJson(this.toJson());
	}
}
